import Sidebar from "../../Components/Sidebar/Sidebar";
import Header from "../../Components/Header/Header";
import classes from "./Patient.module.css";
import AddPatientModal from "./AddPatientModal";
import { 
    FaUsers, 
    FaUserPlus, 
    FaFileImport, 
    FaFileExport, 
    FaProcedures, 
    FaCalendarAlt, 
    FaAmbulance,
    FaSearch, 
    FaFilter, 
    FaRedoAlt,
    FaEllipsisV, 
    FaEye, 
    FaEdit, 
    FaMars, 
    FaVenus 
} from "react-icons/fa";
import { useState, useMemo } from "react";

function Patient() {
    const [showAddPatient, setShowAddPatient] = useState(false);
    
    const stats = [
        {
            title: "Total Patients",
            value: "6,248",
            link: "View all patients",
            icon: <FaUsers />,
            color: "#2F80ED",
            bg: "#EDF5FF",
        },
        {
            title: "New Patients (This Month)",
            value: "326",
            link: "View new patients",
            icon: <FaUserPlus />,
            color: "#27AE60",
            bg: "#ECFFF5",
        },
        {
            title: "Admitted Patients",
            value: "152",
            link: "View admitted",
            icon: <FaProcedures />,
            color: "#9B51E0",
            bg: "#F7EEFF",
        },
        {
            title: "Outpatients (Today)",
            value: "245",
            link: "View outpatients",
            icon: <FaCalendarAlt />,
            color: "#F2994A",
            bg: "#FFF6EB",
        },
        {
            title: "Emergency (Today)",
            value: "56",
            link: "View emergency",
            icon: <FaAmbulance />,
            color: "#EB5757",
            bg: "#FFF0F0",
        },
    ];

    const [search, setSearch] = useState("");
    const [department, setDepartment] = useState("");
    const [status, setStatus] = useState("");
    const [bloodGroup, setBloodGroup] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const rowsPerPage = 5;

    const patients = useMemo(() => [
        {
            id: 1,
            avatar: "https://randomuser.me/api/portraits/men/1.jpg",
            name: "John Doe",
            uhid: "UH10001",
            gender: "Male",
            age: 35,
            dob: "12 Mar 1990",
            phone: "+2348031234567",
            email: "john.doe@gmail.com",
            department: "Cardiology",
            bloodGroup: "O+",
            status: "Active",
            lastVisit: "16 Jul 2026",
        },
        {
            id: 2,
            avatar: "https://randomuser.me/api/portraits/women/2.jpg",
            name: "Mary Johnson",
            uhid: "UH10002",
            gender: "Female",
            age: 29,
            dob: "08 Jan 1997",
            phone: "+2348065551122",
            email: "mary.johnson@gmail.com",
            department: "Neurology",
            bloodGroup: "A+",
            status: "Admitted",
            lastVisit: "15 Jul 2026",
        },
        {
            id: 3,
            avatar: "https://randomuser.me/api/portraits/men/3.jpg",
            name: "Michael Smith",
            uhid: "UH10003",
            gender: "Male",
            age: 42,
            dob: "18 Jun 1983",
            phone: "+2348134423344",
            email: "michael.smith@gmail.com",
            department: "Orthopedics",
            bloodGroup: "B+",
            status: "Discharged",
            lastVisit: "14 Jul 2026",
        },
        {
            id: 4,
            avatar: "https://randomuser.me/api/portraits/women/4.jpg",
            name: "Grace Williams",
            uhid: "UH10004",
            gender: "Female",
            age: 31,
            dob: "25 Dec 1994",
            phone: "+2348057762233",
            email: "grace.williams@gmail.com",
            department: "Pediatrics",
            bloodGroup: "AB+",
            status: "Active",
            lastVisit: "17 Jul 2026",
        },
        {
            id: 5,
            avatar: "https://randomuser.me/api/portraits/men/5.jpg",
            name: "Daniel Brown",
            uhid: "UH10005",
            gender: "Male",
            age: 38,
            dob: "02 May 1987",
            phone: "+2348026678899",
            email: "daniel.brown@gmail.com",
            department: "Dermatology",
            bloodGroup: "O-",
            status: "Admitted",
            lastVisit: "13 Jul 2026",
        },
        {
            id: 6,
            avatar: "https://randomuser.me/api/portraits/women/6.jpg",
            name: "Sophia Davis",
            uhid: "UH10006",
            gender: "Female",
            age: 26,
            dob: "15 Aug 1999",
            phone: "+2348091114455",
            email: "sophia.davis@gmail.com",
            department: "Gynecology",
            bloodGroup: "A-",
            status: "Active",
            lastVisit: "18 Jul 2026",
        },
        {
            id: 7,
            avatar: "https://randomuser.me/api/portraits/men/7.jpg",
            name: "David Wilson",
            uhid: "UH10007",
            gender: "Male",
            age: 47,
            dob: "10 Apr 1978",
            phone: "+2348143346677",
            email: "david.wilson@gmail.com",
            department: "Cardiology",
            bloodGroup: "B-",
            status: "Discharged",
            lastVisit: "11 Jul 2026",
        },
        {
            id: 8,
            avatar: "https://randomuser.me/api/portraits/women/8.jpg",
            name: "Olivia Taylor",
            uhid: "UH10008",
            gender: "Female",
            age: 33,
            dob: "20 Oct 1992",
            phone: "+2348109987766",
            email: "olivia.taylor@gmail.com",
            department: "Endocrinology",
            bloodGroup: "AB-",
            status: "Active",
            lastVisit: "12 Jul 2026",
        },
        {
            id: 9,
            avatar: "https://randomuser.me/api/portraits/men/9.jpg",
            name: "James Anderson",
            uhid: "UH10009",
            gender: "Male",
            age: 54,
            dob: "28 Feb 1971",
            phone: "+2348072228899",
            email: "james.anderson@gmail.com",
            department: "Urology",
            bloodGroup: "O+",
            status: "Admitted",
            lastVisit: "16 Jul 2026",
        },
        {
            id: 10,
            avatar: "https://randomuser.me/api/portraits/women/10.jpg",
            name: "Emma Thomas",
            uhid: "UH10010",
            gender: "Female",
            age: 24,
            dob: "05 Jul 2001",
            phone: "+2348164567890",
            email: "emma.thomas@gmail.com",
            department: "Neurology",
            bloodGroup: "A+",
            status: "Active",
            lastVisit: "18 Jul 2026",
        },
    ], []);

    const filteredPatients = useMemo(() => {
        return patients.filter((patient) => {
            const keyword = search.toLowerCase();

            const searchMatch =
                patient.name.toLowerCase().includes(keyword) ||
                patient.uhid.toLowerCase().includes(keyword) ||
                patient.phone.toLowerCase().includes(keyword) ||
                patient.email.toLowerCase().includes(keyword);

            const departmentMatch =
                department === "" ||
                patient.department === department;

            const statusMatch =
                status === "" ||
                patient.status === status;

            const bloodMatch =
                bloodGroup === "" ||
                patient.bloodGroup === bloodGroup;

            return (
                searchMatch &&
                departmentMatch &&
                statusMatch &&
                bloodMatch
            );
        });
    }, [patients, search, department, status, bloodGroup]);

    const totalPages = Math.ceil(filteredPatients.length / rowsPerPage);
    const indexOfLast = currentPage * rowsPerPage;
    const indexOfFirst = indexOfLast - rowsPerPage;
    const currentPatients = filteredPatients.slice(indexOfFirst, indexOfLast);

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleView = (patient) => {
        console.log("Viewing:", patient);
    };

    const handleEdit = (patient) => {
        console.log("Editing:", patient);
    };

    const handleMore = (patient) => {
        console.log("More Options:", patient);
    };

    const resetFilters = () => {
        setSearch("");
        setDepartment("");
        setStatus("");
        setBloodGroup("");
        setCurrentPage(1);
    };

    return (
        <div className={classes.page}>
            <Sidebar />
            <div className={classes.main}>
                <Header />
                <div className={classes.content}>
                    {/* TOP SECTION */}
                    <div className={classes.top}>
                        <div>
                            <h2>Patients</h2>
                            <div className={classes.breadcrumb}>
                                Dashboard
                                <span>&gt;</span>
                                Patients
                            </div>
                        </div>
                        <div className={classes.actions}>
                            <button className={classes.outline}>
                                <FaFileImport />
                                Import Patients
                            </button>
                            <button className={classes.outline}>
                                <FaFileExport />
                                Export
                            </button>
                            <button
                                className={classes.primary}
                                onClick={() => setShowAddPatient(true)}
                            >
                                + Add New Patient
                            </button>
                        </div>
                    </div>

                    {/* STATS CARDS */}
                    <div className={classes.cards}>
                        {stats.map((item, index) => (
                            <div className={classes.card} key={index}>
                                <div
                                    className={classes.icon}
                                    style={{
                                        background: item.bg,
                                        color: item.color
                                    }}
                                >
                                    {item.icon}
                                </div>
                                <div className={classes.cardInfo}>
                                    <p>{item.title}</p>
                                    <h2>{item.value}</h2>
                                    <button>{item.link}</button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* SEARCH & FILTERS */}
                    <div className={classes.searchContainer}>
                        <div className={classes.searchBox}>
                            <FaSearch className={classes.searchIcon} />
                            <input
                                type="text"
                                placeholder="Search by Name, UHID, Phone, Email..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>

                        <select
                            value={department}
                            onChange={(e) => setDepartment(e.target.value)}
                        >
                            <option value="">All Departments</option>
                            <option>Cardiology</option>
                            <option>Pediatrics</option>
                            <option>Orthopedics</option>
                            <option>Dermatology</option>
                            <option>Neurology</option>
                            <option>Gynecology</option>
                            <option>Urology</option>
                            <option>Endocrinology</option>
                        </select>

                        <select
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="">All Status</option>
                            <option>Active</option>
                            <option>Admitted</option>
                            <option>Discharged</option>
                        </select>

                        <select
                            value={bloodGroup}
                            onChange={(e) => setBloodGroup(e.target.value)}
                        >
                            <option value="">All Blood Groups</option>
                            <option>A+</option>
                            <option>A-</option>
                            <option>B+</option>
                            <option>B-</option>
                            <option>AB+</option>
                            <option>AB-</option>
                            <option>O+</option>
                            <option>O-</option>
                        </select>

                        <button className={classes.filterBtn}>
                            <FaFilter />
                            More Filters
                        </button>

                        <button
                            className={classes.resetBtn}
                            onClick={resetFilters}
                        >
                            <FaRedoAlt />
                            Reset
                        </button>
                    </div>

                    {/* TABLE */}
                    <div className={classes.tableContainer}>
                        <table className={classes.table}>
                            <thead>
                                <tr>
                                    <th>Patient</th>
                                    <th>UHID</th>
                                    <th>Gender</th>
                                    <th>Age</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Department</th>
                                    <th>Status</th>
                                    <th>Last Visit</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentPatients.length > 0 ? (
                                    currentPatients.map((patient) => (
                                        <tr key={patient.id}>
                                            <td>
                                                <div className={classes.patientInfo}>
                                                    <img
                                                        src={patient.avatar}
                                                        alt={patient.name}
                                                        className={classes.avatar}
                                                    />
                                                    <div>
                                                        <h4>{patient.name}</h4>
                                                        <span>DOB : {patient.dob}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{patient.uhid}</td>
                                            <td>
                                                <div className={classes.gender}>
                                                    {patient.gender === "Male" ? (
                                                        <>
                                                            <FaMars className={classes.male} />
                                                            Male
                                                        </>
                                                    ) : (
                                                        <>
                                                            <FaVenus className={classes.female} />
                                                            Female
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                            <td>{patient.age}</td>
                                            <td>{patient.phone}</td>
                                            <td>{patient.email}</td>
                                            <td>{patient.department}</td>
                                            <td>
                                                <span
                                                    className={`${classes.badge}
                                                    ${patient.status === "Active"
                                                        ? classes.active
                                                        : patient.status === "Admitted"
                                                        ? classes.admitted
                                                        : classes.discharged
                                                    }`}
                                                >
                                                    {patient.status}
                                                </span>
                                            </td>
                                            <td>{patient.lastVisit}</td>
                                            <td>
                                                <div className={classes.tableActions}>
                                                    <button
                                                        onClick={() => handleView(patient)}
                                                        className={classes.viewBtn}
                                                    >
                                                        <FaEye />
                                                    </button>
                                                    <button
                                                        onClick={() => handleEdit(patient)}
                                                        className={classes.editBtn}
                                                    >
                                                        <FaEdit />
                                                    </button>
                                                    <button
                                                        onClick={() => handleMore(patient)}
                                                        className={classes.moreBtn}
                                                    >
                                                        <FaEllipsisV />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" style={{ textAlign: "center", padding: "40px" }}>
                                            No Patients Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* PAGINATION */}
                    <div className={classes.pagination}>
                        <p>
                            Showing
                            <strong>
                                {" "}
                                {filteredPatients.length > 0 ? indexOfFirst + 1 : 0}
                                -
                                {Math.min(indexOfLast, filteredPatients.length)}
                            </strong>
                            {" "}of{" "}
                            <strong>{filteredPatients.length}</strong>
                            patients
                        </p>
                        <div className={classes.pages}>
                            <button
                                onClick={() => goToPage(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>
                            {Array.from({ length: totalPages }, (_, i) => (
                                <button
                                    key={i}
                                    onClick={() => goToPage(i + 1)}
                                    className={currentPage === i + 1 ? classes.activePage : ""}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            <button
                                onClick={() => goToPage(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <AddPatientModal
                show={showAddPatient}
                onClose={() => setShowAddPatient(false)}
            />
        </div>
    );
}

export default Patient;